import React from 'react';
import { FileTextIcon, ImageIcon, DownloadIcon, ZapIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
export function AppPromo() {
  return <section className="py-20 bg-gradient-to-br from-purple-600 via-purple-700 to-purple-800 text-white relative overflow-hidden" data-id="element-11">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-12">
        <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl animate-pulse" data-id="element-13"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse delay-1000" data-id="element-14"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <div className="inline-block mb-4" data-id="element-17">
            <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-semibold" data-id="element-18">
              🚀 Nueva Herramienta
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-19">
            Aplicación Web de Extracción de Datos
          </h2>
          <p className="text-xl text-purple-100 max-w-3xl mx-auto" data-id="element-20">
            Agiliza tu trabajo contable extrayendo información de PDFs e
            imágenes con eficiencia
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-21">
          {/* Features */}
          <div className="space-y-6" data-id="element-22">
            <div className="flex items-start space-x-4 bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all" data-id="element-23">
              <FileTextIcon className="w-8 h-8 text-purple-200 flex-shrink-0" data-id="element-24" />
              <div data-id="element-25">
                <h3 className="text-xl font-bold mb-2" data-id="element-26">Extracción de PDFs</h3>
                <p className="text-purple-100" data-id="element-27">
                  Extrae datos de facturas, estados de cuenta y documentos
                  contables en formato PDF
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4 bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all" data-id="element-28">
              <ImageIcon className="w-8 h-8 text-purple-200 flex-shrink-0" data-id="element-29" />
              <div data-id="element-30">
                <h3 className="text-xl font-bold mb-2" data-id="element-31">
                  Procesamiento de Imágenes
                </h3>
                <p className="text-purple-100" data-id="element-32">
                  Convierte imágenes de documentos en datos estructurados listos
                  para usar
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4 bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all" data-id="element-33">
              <DownloadIcon className="w-8 h-8 text-purple-200 flex-shrink-0" data-id="element-34" />
              <div data-id="element-35">
                <h3 className="text-xl font-bold mb-2" data-id="element-36">
                  Exportación CSV/Excel
                </h3>
                <p className="text-purple-100" data-id="element-37">
                  Descarga los datos extraídos en formatos compatibles con tus
                  sistemas contables
                </p>
              </div>
            </div>
          </div>

          {/* Benefits */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20" data-id="element-38">
            <h3 className="text-2xl font-bold mb-6" data-id="element-39">Beneficios</h3>
            <ul className="space-y-4" data-id="element-40">
              {[{
              icon: ZapIcon,
              text: 'Reduce el tiempo de captura de datos en un 90%'
            }, {
              icon: CheckCircleIcon,
              text: 'Minimiza errores de transcripción manual'
            }, {
              icon: ClockIcon,
              text: 'Procesa múltiples documentos simultáneamente'
            }, {
              icon: CheckCircleIcon,
              text: 'Integración directa con sistemas contables'
            }].map((benefit, index) => <li key={index} className="flex items-center space-x-3" data-id="element-41">
                  <benefit.icon className="w-6 h-6 text-purple-300 flex-shrink-0" data-id="element-42" />
                  <span className="text-purple-50" data-id="element-43">{benefit.text}</span>
                </li>)}
            </ul>

            <div className="mt-8 pt-8 border-t border-white/20" data-id="element-44">
              <a href="https://app.kontaxes.com" target="_blank" rel="noopener noreferrer" className="block w-full py-4 bg-white text-purple-700 font-bold text-center rounded-xl hover:bg-purple-50 transition-all transform hover:scale-105 shadow-lg" data-id="element-45">
                Acceder a la Aplicación →
              </a>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-46">
          <p className="text-purple-200 text-sm" data-id="element-47">
            💡 Disponible para todos los clientes de KONTAXES
          </p>
        </div>
      </div>
    </section>;
}